import '../css/landing.css';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet'; // Leaflet package for using custom icons
import 'bootstrap-icons/font/bootstrap-icons.css'; // Bootstrap Icons
import 'leaflet/dist/leaflet.css';

// Coordinates for the location (you can change these to any desired coordinates)
const position = [9.03, 38.74]; // Example coordinates (Addis Ababa, Ethiopia)

export default function Landing() {

    // Correctly initialize a custom Leaflet icon using Bootstrap Icons
    const customIcon = new L.DivIcon({
        className: 'leaflet-div-icon',
        html: '<i class="bi bi-geo-alt-fill" style="font-size: 32px; color: #FF5733;"></i>',
        iconSize: [30, 30], // You can adjust this size as needed
    });

    return (
        <div className="landing">
            <div className="mission">
                <h2 className="mission-title">ማህበሩ አድራሻ</h2>
                <p className="mission-description">
                    በቦሌ ደብረ ሳሌም ቅዱስ ዮሐንስ መድኃኔዓለም ቤተክርስቲያን ፣ አቡነ አረጋዊ ቤተክርስቲያን ፣ በኢ/ኦ ተዋህዶ ቤ/ክ
                </p>
            </div>

            <div className="map-container">
                <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {/* Use the custom icon for the marker */}
                    <Marker position={position} icon={customIcon}>
                        <Popup>
                            Mahibere Kidusan Building | 5 Kilo | ማህበር ቅዱሳን ህንጻ | 5 ኪሎ · Arada 11/12, Ethiopia 
                            <br />
                            <a href="https://maps.app.goo.gl/BoerC89tM6vXbqNk7" target="_blank" rel="noopener noreferrer">
                                Open in Google Maps
                            </a>
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
}
